import {DataTableSortStatus} from 'mantine-datatable';
import {TestDefinition} from '../types';

// ⚠️ THE COMPARATOR DOES NOT LIVE HERE (FNP-912 / FNP-923).
//
// Nulls-last, numeric-vs-string and empty-string-as-missing are published once in
// `@flexinet/ui-components`:
//
//     import {useTableSort} from '@flexinet/ui-components';
//
// What remains is the one genuinely per-entity decision: WHICH key this table
// sorts by. How to compare two values is universal; what "most important first"
// means for a test definition is not.

// DEFAULT: newest first, keyed on `created`.
//
// ⚠️ `created` is NULLABLE on TestDefinition (`created: AWSDateTime` in the
// live schema), which is the risk the module checklist flags: if every row
// lacked it the "sort" would silently degrade to insertion order. It is used
// anyway because the API populates it on write, and because nulls sort LAST in
// the shared comparator, so a row missing it lands at the bottom rather than
// corrupting the order of the rows that have it.
//
// It is NOT `updated`: that moves whenever someone edits a definition, so the
// list would reorder itself under an operator who is reading it. `created` is
// immutable, which is what makes it safe as a default.
export const DEFAULT_SORT: DataTableSortStatus<TestDefinition> = {
    columnAccessor: 'created',
    direction: 'desc',
};
